<template>
    <div>
        <Breadcrumbs main="Vendors" title="Vendor Insights"></Breadcrumbs>

        
        <!-- <div class="form-group">
            <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
        </div> -->
        <div class="container-fluid">
            <div class="row ">
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-cart" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total Vendors</span>
                          <h4 class="mb-0 counter">{{ vendors }}</h4><feather type="shopping-cart" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-cart" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Monthly Vendors</span>
                          <h4 class="mb-0 counter">{{ vendorMonth }}</h4><feather type="shopping-cart" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Rated</span>
                          <h4 class="mb-0 counter"> {{ rated.business }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Rated</span>
                          <h4 class="mb-0 counter"> {{ rated.rate }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-secondary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Least rated  </span>
                          <h4 class="mb-0 counter">{{ leastRated.business }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-secondary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Least Rate </span>
                          <h4 class="mb-0 counter">{{ leastRated.rate }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-bag" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Ordered</span>
                          <h4 class="mb-0 counter">{{ ordered.vendor }}</h4><feather type="shopping-bag" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-bag" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Most Orders</span>
                          <h4 class="mb-0 counter">{{  ordered.value }}</h4><feather type="shopping-bag" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <!-- <div v-if="!userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Rated</span>
                          <h4 class="mb-0 counter"> {{ rated }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'VendorReport',
        data() {
            return {
                vendors: 0,
                vendorMonth: 0,
                rated: 0,
                ratedMonth: 0,
                ordered: 0,
                orderedMonth: 0,
                users: 0,
                userMonth: 0,
                leastRated: 0,
                reportOptions: [
                                    { value: null, text: 'Select Report' },
                                    { value: 'T', text: 'Today' },
                                    { value: 'W', text: 'This Week' },
                                    { value: 'M', text: 'This Month' },
                                    { value: 'Y', text: 'This Year' },
                                    { value: 'PW', text: 'Previous Week' },
                                    { value: 'PM', text: 'Previous Month' },
                                    { value: 'PY', text: 'Previous Year' },
                            ],
                report: null,
                items: []
            }
        },
        computed: {
            userAdmin() {
            return localStorage.getItem('type') == "admin" ? true : false
            },
            getUser() {
            return this.$store.getters['authentication/getUser']
            }
        },
        created() {
            // watch and fetch
            this.$watch(
            () => this.$route.$params,
            () => {
                this.fetchData()
            },
            { immediate: true }

            )

        },
        methods: {
            fetchData() {
                
                const url =  '/vendor/' 

                axios.get(url)
                  .then(response=>{
                    //
                    this.items = response.data
                    this.vendors = this.items.length

                    //
                    // this.male = this.items.filter(u=> u.gender == 'male').length
                    // this.female = this.items.filter(u=> u.gender == 'female').length

                    for (let index = 0; index < this.items.length; index++) {

                          // date
                          if (this.items[index].createdAt) {
                            this.items[index].date =  (new Date(this.items[index].createdAt)).toISOString() 
                          
                          }

                          this.items[index].rate = this.items[index].ratings.length > 0 ? (parseFloat(this.items[index].ratings.reduce((a, b) => a + b, 0) ))/this.items[index].ratings.length  : 0
                          // console.log(this.items[index].rate)
                          
                      }

                      const month = new Date().toISOString().substring(0,7)
                      // const today = new Date().toISOString().substring(0,10)
                      this.vendorMonth = this.items.filter(u=> u.date.includes(month)).length
                      // this.usersToday = this.items.filter(u=> u.date.includes(today)).length
                      this.rated = this.items.reduce((a, b) =>a.rate > b.rate ? a : b, 1)
                      this.leastRated = this.items.reduce((a, b) =>a.rate < b.rate ? a : b, 1)
                      this.ratedMonth = this.items.filter(u=> u.date.includes(month)).reduce((a, b) => a.rate > b.rate ? a : b, 1)

                      this.usersWeek = this.items.filter(u=> this.getWeek().includes(u.date.substring(0,10))).length
                  })
                  .catch( e => {
                    this.$swal({
                      title:"Failed!",
                      text:e.response.data,
                      type:'error'
                    });
                  })


                  const url2 =  '/order/' 

                  axios.get(url2)
                  .then(response=>{
                    //
                    this.orders = response.data
                    this.getMostOrdered()
                    // this.vendors = this.items.length
                  })
                  .catch( e => {
                    this.$swal({
                      title:"Failed!",
                      text:e.response.data,
                      type:'error'
                    });
                  })

                  

            },
            getMostOrdered() {

              const data = this.orders
              const vendors = this.items.map(v=>v.business)

              // let pref = []

              // for (let index = 0; index < data.length; index++) {

              //   pref.push(data[index].preferences)
                                
              // }

              // let allpref = pref.flat()

              let array = []

              for (let index = 0; index < vendors.length; index++) {
                //
                let c = 0;

                data.forEach(v=>v.vendor === vendors[index] && c++)
                              
                array.push ({ vendor: vendors[index], value: c });

              }
                            
              // array.sort(function(a, b) {
              //   return parseFloat(b.value) - parseFloat(a.value);
              // });

              // console.log(array.reduce((a, b) =>a.value > b.value ? a : b, 1))

              // this.pref = array

              this.ordered = array.reduce((a, b) =>a.value > b.value ? a : b, 1)

            },
            getReport() {
                console.log(this.report)
            },
            getWeek(date) {

              var curr = date ? new Date(date) : new Date(); // get current date
              var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
              // var last = first + 6; // last day is the first day + 6

              var firstday = new Date(curr.setDate(first)).toDateString().substring(4);
              // var lastday = new Date(curr.setDate(last)).toDateString().substring(4);

              let days =[]
              //
              for (let index = 0; index < 7; index++) {

                const d = moment(firstday).add(index, 'days').toDate().toISOString().substring(0,10)
                
                days.push(d)
              }

              // console.log(days)
              return days

            },
            // getReport() {
            //     console.log(this.report)
            // }
        }
    }
</script>

<style lang="scss" scoped>

</style>